<div id="page-size-label-{{cid}}" class="sr-only">{{locale "recordsPerPage"}}</div>
<nav aria-labelledby="page-size-label-{{cid}}">
	<div class="paginate-page-size"></div>
    <span>{{locale "perPage"}}</span>
</nav>
